import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "terms-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open = true)),
      class: "therm-modal-button"
    }, "Terms and Service"),
    (_ctx.open)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          name: "Terms of Service",
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open = false)),
          style: {"max-height":"90vh"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.terms, (term) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: term.title
                }, [
                  _createElementVNode("h3", null, _toDisplayString(term.title), 1),
                  _createElementVNode("p", null, _toDisplayString(term.content), 1)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}